import * as z from "../../../framework";
import * as ui from "../ui";
import { usingSso } from "../util/util";

var view = () => new ui.Container({
    classes: "mar-t-20",
    components: [
        new ui.Container({
            bsc: "col-xs-12",
            components: [
                new ui.Container({
                    bsc: "col-xs-offset-1 col-xs-9",
                    childBsc: "col-xs-6",
                    components: [
                        new ui.TextBox({
                            id: "FirstName",
                            label: "FirstName",
                            bindValue: "FirstName",
                            required: !usingSso(),
                            infoTooltip: usingSso() ? "SSOPreventUserNameChange" : undefined,
                            readOnly: usingSso()
                        }),
                        new ui.TextBox({
                            id: "LastName",
                            label: "LastName",
                            bindValue: "LastName",
                            required: !usingSso(),
                            infoTooltip: usingSso() ? "SSOPreventUserNameChange" : undefined,
                            readOnly: usingSso()
                        })
                    ]
                })
            ]
        })
    ]
});

export default view;
